import { forwardRef, useId } from 'react';
import classNames from 'classnames';

export const Input = forwardRef(
  (
    {
      size = 'base',
      disabled = false,
      onChange,
      value = '',
      id,
      label = '',
      placeholder = null,
      error = '',
      className,
      labelClassName,
      wrapperClassName,
      charLimit = null,
      ...props
    },
    ref,
  ) => {
    const errorId = `input-error-${useId()}`;
    let inputId = useId();
    inputId = id ?? inputId;

    return (
      <div className={classNames('w-full relative', wrapperClassName)}>
        {!!label && (
          <label
            htmlFor={inputId}
            className={classNames('mb-1.25 block text-white font-semibold leading-none', labelClassName)}
          >
            {label}
          </label>
        )}
        {charLimit != null ? (
          <div
            className={classNames('absolute right-0 top-0 text-2xs', {
              'text-gray-200': (value?.length || 0) <= charLimit,
              'text-red-500': (value?.length || 0) > charLimit,
            })}
          >
            {value?.length || 0}/{charLimit}
          </div>
        ) : null}
        <input
          ref={ref}
          className={classNames(
            'w-full rounded-md border outline-none focus:outline-none placeholder:text-gray-300 text-sm',
            className,
            {
              'h-[30px] px-2.5': size === 'base',
              'h-[37px] px-3.75': size === 'lg',
              'border-transparent focus:border-blue-500': !error,
              'bg-gray-500 text-white': !disabled,
              'bg-gray-600 text-gray-200': disabled,
              'border-red-500 focus:border-red-500': !!error,
            },
          )}
          id={inputId}
          disabled={disabled}
          onChange={onChange}
          value={value}
          placeholder={placeholder}
          aria-invalid={!!error}
          aria-describedby={error ? errorId : null}
          {...props}
        />

        {!!error && typeof error === 'string' && (
          <div className="relative h-5 mt-0.5" id={errorId}>
            <div className="text-red-500 text-xs absolute whitespace-nowrap">{error}</div>
          </div>
        )}
        {!!error && typeof error !== 'string' && typeof error !== 'boolean' && (
          <div className="text-red-500 text-xs min-h-[20px] translate-y-0.5" id={errorId}>
            {error}
          </div>
        )}
      </div>
    );
  },
);
